$(function() {
  /**
   * link_to("/path", "タイトル", data: { popup: true })というようにすると、
   * ページ遷移ではなくポップアップウィンドウが開くようになります
   */
  $('a[data-popup]').on('click', function(e) {
    window.open($(this).attr('href'), "Popup", "height=600, width=600");
    e.preventDefault()
  })
})
